import Vue from 'vue'

export const getApiLog = params => {
  return Vue.fetch.post('/apiv1/requestLog/findByPage', params)
}

export const getLogsList = params => {
  return Vue.fetch.post('/apiv1/api_log/logs', params)
}



// WEBPACK FOOTER //
// ./src/services/logApi.js